<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 583.177 1080" class="pointer-events-none">
    <defs>
      <symbol id="Cursor" data-name="Cursor" viewBox="0 0 103.071 35.127">
        <path class="cls-1" d="M101.071,0h-92a2,2,0,0,0-2,2V8.929L0,16l7.071,7.071V30a2,2,0,0,0,2,2h92a2,2,0,0,0,2-2V2A2,2,0,0,0,101.071,0Z" />
        <text class="cls-3" transform="translate(42.0712 11.9995)">CURRENT</text>
        <text class="cls-4" transform="translate(41.0712 26.9995)">FLOOR</text>
        <path class="cls-8" d="M34.071,16a1.2029,1.2029,0,0,1-.1088.4561,9.9016,9.9016,0,0,1-17.7823,0,1.01,1.01,0,0,1,0-.9122,9.9016,9.9016,0,0,1,17.7823,0A1.1984,1.1984,0,0,1,34.071,16Zm-1,0a10.7758,10.7758,0,0,0-4.0556-4.042,5,5,0,1,1-7.8887,0A10.7768,10.7768,0,0,0,17.071,16a8.9,8.9,0,0,0,16,0Zm-12-1a4,4,0,1,0,4-4A4.0015,4.0015,0,0,0,21.071,15Zm2,0c0-.03.0093-.0576.0093-.0889A1.7828,1.7828,0,0,0,23.5867,15a1.4849,1.4849,0,0,0,1.4843-1.4844,1.7889,1.7889,0,0,0-.0888-.5068c.03-.001.0576-.0088.0888-.0088a2,2,0,1,1-2,2Z" />
      </symbol>
    </defs>

    <g>
      <image width="2462" height="3128" transform="translate(0 171.2735) scale(0.2356 0.2356)" xlink:href="images/Tower.png" />
      <use v-if="translate" width="103.071" height="35.1274" :transform="translate" class="transition-all duration-500 pointer-events-auto" xlink:href="#Cursor" @click="$router.push('/vr-tour')" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'FloorTower',
  props: {
    floor: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      positions: [
        { floor: 'Ground', x: 457.1059, y: 801 },
        { floor: '06', x: 457.1059, y: 691 },
        { floor: '07', x: 457.1059, y: 675 },
        { floor: '08', x: 457.1059, y: 659 },
        { floor: '09', x: 457.1059, y: 643 },
        { floor: '10', x: 457.1059, y: 627 },
        { floor: '11', x: 457.1059, y: 611 },
        { floor: '12', x: 457.1059, y: 595 },
        { floor: '12A', x: 457.1059, y: 579 },
        { floor: '14', x: 457.1059, y: 563 },
        { floor: '15', x: 457.1059, y: 547 },
        { floor: '16', x: 457.1059, y: 531 },
        { floor: '17', x: 457.1059, y: 515 },
        { floor: '18', x: 457.1059, y: 499 },
        { floor: '19', x: 457.1059, y: 483 },
        { floor: '20', x: 457.1059, y: 467 },
        { floor: '21', x: 457.1059, y: 451 },
        { floor: '22', x: 457.1059, y: 435 },
        { floor: '23', x: 457.1059, y: 419 },
        { floor: '24', x: 457.1059, y: 403 },
        { floor: '25', x: 457.1059, y: 387 },
        { floor: '26', x: 457.1059, y: 371 },
        { floor: '27', x: 457.1059, y: 355 },
        { floor: '28', x: 457.1059, y: 339 },
        { floor: '29', x: 457.1059, y: 323 },
        { floor: '30', x: 457.1059, y: 307 },
        { floor: '31', x: 457.1059, y: 291 },
        { floor: '32', x: 457.1059, y: 250 },
        { floor: '33', x: 457.1059, y: 234 },
        { floor: 'Rooftop 01', x: 457.1059, y: 218 },
        { floor: 'Rooftop 02', x: 457.1059, y: 218 },
      ],
    }
  },
  computed: {
    translate () {
      const pos = this.positions.find(({ floor }) => floor === this.floor.name)
      return pos ? `translate(${pos.x} ${pos.y})` : null
    },
  },
  methods: {
    onClick (e) {
      const el = e.target.closest('[data-name]')

      if (el) {
        this.$router.push('/vr-tour')
      }
    },
  },
}
</script>

<style>
.cls-1 {
  fill: #131313;
}

.cls-2,
.cls-3,
.cls-4 {
  isolation: isolate;
}

.cls-3 {
  font-size: 10px;
  font-family: CPN;
}

.cls-3,
.cls-4,
.cls-8 {
  fill: #fff;
}

.cls-4 {
  font-size: 16px;
  font-family: CPN;
  font-weight: 700;
}

.cls-5 {
  letter-spacing: -0.02em;
}

.cls-6 {
  letter-spacing: 0.01em;
}

.cls-7 {
  letter-spacing: 0em;
}
</style>
